













  import {Component, Vue} from 'vue-property-decorator';
  import DropImage from '../components/DropImage.vue';
  import {getUrlParams} from '@/utils';

  @Component({
  components: {
    DropImage
  }
})
export default class ORMConverter extends Vue {
  private _occlusionImageData: ImageData | undefined;
  private _roughnessImageData: ImageData | undefined;
  private _metallicImageData: ImageData | undefined;

  mounted() {
    //lel
  }

  occlusionLoaded(imageData: ImageData) {
    this._occlusionImageData = imageData;
    this.updateORM(imageData);
  }

  roughnessLoaded(imageData: ImageData) {
    this._roughnessImageData = imageData;
    this.updateORM(imageData);
  }

  metallicLoaded(imageData: ImageData) {
    this._metallicImageData = imageData;
    this.updateORM(imageData);
  }

  updateORM(latest: ImageData) {
    const imageData = new ImageData(
      new Uint8ClampedArray(latest.data),
      latest.width,
      latest.height
    );
    const {defaultOcclusion, defaultMetallic, defaultRoughness} = getUrlParams();
    const { width, height } = imageData;

    const resultCanvas = this.$el.querySelector(
      ".orm-image"
    ) as HTMLCanvasElement;
    resultCanvas.width = width;
    resultCanvas.height = height;
    const resultCanvasContext = resultCanvas.getContext(
      "2d"
    ) as CanvasRenderingContext2D;

    for (let y = 0; y < height; y++) {
      for (let x = 0; x < width; x++) {
        const i = y * 4 * width + x * 4;

        let occlusionAVG = defaultOcclusion || 255;
        if (this._occlusionImageData) {
          occlusionAVG =
            (this._occlusionImageData.data[i] +
              this._occlusionImageData.data[i + 1] +
              this._occlusionImageData.data[i + 2]) /
            3;
        }
        imageData.data[i] = occlusionAVG;

        let roughnessAVG = defaultRoughness || 255;
        if (this._roughnessImageData) {
          roughnessAVG =
            (this._roughnessImageData.data[i] +
              this._roughnessImageData.data[i + 1] +
              this._roughnessImageData.data[i + 2]) /
            3;
        }
        imageData.data[i + 1] = roughnessAVG;

        let metallicAVG = defaultMetallic || 255;
        if (this._metallicImageData) {
          metallicAVG =
            (this._metallicImageData.data[i] +
              this._metallicImageData.data[i + 1] +
              this._metallicImageData.data[i + 2]) /
            3;
        }
        imageData.data[i + 2] = metallicAVG;
      }
    }

    resultCanvasContext.putImageData(
      imageData,
      0,
      0,
      0,
      0,
      imageData.width,
      imageData.height
    );
  }
}
